/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class CustomerOpportunityOverview extends JSONable {

  uuid: string | undefined = undefined;
  opportunityName: string | undefined = undefined;
  opportunityType: string | undefined = undefined;
  businessRenewalDate: string | undefined = undefined;
  pipelineStage: string | undefined = undefined;
  firstShipmentExpectedDate: string | undefined = undefined;
  serviceType: string | undefined = undefined;
  shipmentType: string | undefined = undefined;
  totalPotentialRevenueGP: number | undefined = undefined;
}
